<template>
  <div>
    <b-modal
      ref="list-serial-modal"
      hide-footer
      :titleHtml="modalTitle"
      size="md"
    >
      <b-row class="mb-3">
        <b-col cols="6">
          <b-input
            placeholder="Nhập số khung/ số máy / số seri"
            v-model="search"
            size="sm"
          ></b-input
        ></b-col>
        <b-col cols="1" class="pl-0">
          <b-button
            class="filter-btn"
            variant="primary"
            size="sm"
            @click="fetchData(productId)"
            >Lọc
          </b-button>
        </b-col>
      </b-row>
      <v-form ref="form" lazy-validation>
        <b-table
          :items="listItem"
          :fields="fields"
          bordered
          hover
          :busy="onLoading"
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="3"></vcl-table>
          </template>
          <template v-slot:cell(imeiCode)="row">
            <div class="d-flex justify-content-center">
              <span v-text="row.item.imeiCode"></span>
            </div>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="d-flex justify-content-center">
              <v-icon
                small
                class="text-danger"
                @click="applySerialNumber(row.item)"
                v-b-tooltip
                title="Áp dụng"
                >mdi-pen</v-icon
              >
            </div>
          </template>
        </b-table>

        <b-pagination-nav
          v-if="totalPages"
          v-model="page"
          class="custom-pagination"
          v-show="totalPages >= 2"
          :number-of-pages="totalPages"
          :link-gen="() => '#'"
          @change="handlePageChange"
          align="right"
          first-class="page-item-first btn btn-icon btn-sm m-1"
          prev-class="page-item-prev btn btn-icon btn-sm m-1"
          next-class="page-item-next btn btn-icon btn-sm m-1 "
          last-class="page-item-last btn btn-icon btn-sm m-1 "
          page-class="btn btn-icon btn-sm border-0 m-1"
        >
          <template v-slot:first-text>
            <span>
              <i class="ki ki-bold-double-arrow-back icon-xs"></i>
            </span>
          </template>

          <template v-slot:prev-text>
            <i class="ki ki-bold-arrow-back icon-xs"></i>
          </template>

          <template v-slot:next-text>
            <i class="ki ki-bold-arrow-next icon-xs"></i>
          </template>

          <template v-slot:last-text>
            <span class="text-info">
              <i class="ki ki-bold-double-arrow-next icon-xs"></i>
            </span>
          </template>
        </b-pagination-nav>

        <b-button
          style="font-weight: 600; width: 70px"
          variant="secondary"
          size="sm"
          @click="hideModal"
          >Hủy</b-button
        >
      </v-form>
    </b-modal>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { VclTable } from 'vue-content-loading';
import { convertPrice } from '../../../utils/common';
export default {
  props: ['billItemId', 'productName', 'storeId', 'productId'],
  data() {
    return {
      search: null,
      modalTitle: '',
      searchText: '',
      listItem: [],
      totalPages: 0,
      page: 1,
      fields: [
        {
          key: 'serialNumber',
          label: 'Số seri',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '60%',
          },
        },
        // {
        //   key: 'engineNumber',
        //   label: 'Số máy',
        //   sortable: false,
        //   thStyle: {
        //     fontWeight: 600,
        //     color: '#181c32',
        //     textAlign: 'center',
        //     width: '60%',
        //   },
        // },
        {
          key: 'sellingPrice',
          label: 'Giá bán',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '30%',
          },
          tdClass: 'text-right',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        { key: 'actions', label: '' },
      ],
      onLoading: false,
    };
  },
  components: {
    VclTable,
  },
  watch: {},
  methods: {
    convertPrice,
    handlePageChange(newPage) {
      this.page = newPage;
      this.fetchData(this.productId);
    },
    fetchData(productId) {
      this.onLoading = true;
      const param = {
        search: this.search,
        productId: productId,
        storeId: this.storeId,
        page: this.page,
        limit: 10,
        status: ['NEW'],
      };
      const paramQuery = {
        params: param,
      };
      ApiService.query('products/serial', paramQuery)
        .then(({ data }) => {
          this.listItem = data.data.data.map((element) => {
            return {
              id: element.id,
              serialNumber: element.serialNumber,
              // originalPrice: element.originalPrice ? element.originalPrice : 0,
              sellingPrice: element.sellingPrice ? element.sellingPrice : 0,
            };
          });
          this.totalPages = data.data.paginations.totalPages;
          this.page = data.data.paginations.currentPage;
          this.onLoading = false;
        })
        .catch(() => {
          this.onLoading = false;
        });
    },
    showModal: function (productId) {
      this.fetchData(productId);
      this.modalTitle = `<div>
              <span class='d-block' style='font-size: 1.1rem'>Danh sách seri sản phẩm: <a class='text-primary'>#${this.productName}</a></span>
              </div>`;
      this.$refs['list-serial-modal'].show();
    },
    hideModal: function () {
      this.$refs['list-serial-modal'].hide();
    },
    // applyImei(id) {
    //   this.$emit('applyImei', id);
    //   this.hideModal();
    // },
    applySerialNumber(data) {
      this.$emit('applySerialNumber', data);
      this.hideModal();
    },
  },
};
</script>
